<div>
  <div class="flex flex-row flex-wrap align-items-center my-3">
    <h3 class="text-base font-medium text-800 pr-2">
      {{'UserPages.UserChangePassword.PageTitle' | translate}}
    </h3>
  </div>

  <form [formGroup]="formGroup">
    <div class="flex flex-column">
      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="oldPassword">{{'UserPages.UserChangePassword.CurrenPasswordFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <p-password
            id="oldPassword"
            formControlName="oldPassword"
            [minlength]="8"
            [feedback]="false"
            [toggleMask]="true"
            class="custom-input-password"></p-password>
          <small *ngIf="submit && formGroup.controls['oldPassword'].invalid"
            class="p-error">{{getErrorMessage('oldPassword')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-3">
          <label for="newPassword">{{'UserPages.UserChangePassword.NewPasswordFieldLabel' | translate}} *</label>
        </div>
        <div class="w-9">
          <p-password
            id="newPassword"
            formControlName="newPassword"
            [minlength]="8"
            [toggleMask]="true"
            class="custom-input-password">
            <ng-template pTemplate="header">
              <h6>{{'UserPages.UserChangePassword.SubtitlePassword' | translate}}</h6>
            </ng-template>
            <ng-template pTemplate="footer">
              <p-divider></p-divider>
              <p class="mt-2">{{'UserPages.UserChangePassword.PasswordSubtitle' | translate}}</p>
              <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                <li>{{'UserPages.UserChangePassword.PasswordSuggestion1' | translate}}</li>
                <li>{{'UserPages.UserChangePassword.PasswordSuggestion2' | translate}}</li>
                <li>{{'UserPages.UserChangePassword.PasswordSuggestion3' | translate}}</li>
                <li>{{'UserPages.UserChangePassword.PasswordSuggestion4' | translate}}</li>
              </ul>
            </ng-template>
          </p-password>
          <small *ngIf="submit && formGroup.controls['newPassword'].invalid"
            class="p-error">{{getErrorMessage('newPassword')}}</small>
        </div>
      </div>

      <div class="flex w-12 mt-2">
        <span class="font-italic text-sm text-500">
          {{'UserPages.UserChangePassword.PasswordRestrictionText' | translate}}
        </span>
      </div>

      <div class="flex w-12 mt-2">
        <p-button
          [loading]="loading"
          label="{{'UserPages.UserChangePassword.ChangePasswordButton' | translate}}"
          (onClick)="save()"
          class="custom-text-button"></p-button>
      </div>
      <div class="flex w-12 mt-3">
        <p-button
          label="{{'UserPages.UserChangePassword.ForgotPasswordButton' | translate}}"
          styleClass="p-button-outlined"
          (onClick)="goToChangePasswordPage()"
          class="custom-text-button"></p-button>
      </div>
    </div>
  </form>

  <div class="flex justify-content-between flex-wrap align-items-center mt-3">
    <h3 class="text-base font-medium text-800 pr-2">
      {{'UserPages.UserChangePassword.TwoStepAuthenticationTitle' | translate}}
    </h3>
  </div>
  <div class="flex flex-column">
    <div class="w-12">
      <span>{{'UserPages.UserChangePassword.TwoStepAuthenticationText' | translate}}.</span>
    </div>
    <div *ngIf="showSwitch" class="w-12">
      <span id="switch1" style="font-weight: bold;">{{authLabel}}</span>
      <p-inputSwitch
        [(ngModel)]="isTwoAuth"
        inputId="switch1"
        class="ml-2"
        (onChange)="toggleAuth()"></p-inputSwitch>
    </div>
    <div *ngIf="showAuthentication" class="grid col-6 sm:col-12">
      <form [formGroup]="formGroup2FA">
        <div class="p-fluid grid flex col-6 md:col-6 sm:col-12">
          <div class="col-12 mb-2">
            <span>{{'LoginPage.VerifiedCodeText' | translate}}</span>
          </div>
          <div class="col-2">
            <p-inputNumber #authCode1 [min]="0" [max]="9" formControlName="authCode1" [maxlength]="1" [useGrouping]="false"
              class="p-inputtext-sm custom-input-number" (onInput)="handleFocusNext(authCode2)" (onFocus)="clear('authCode1')" (paste)="onPaste($event)" [style]="{'text-aling':'center'}">
            </p-inputNumber>
          </div>

          <div class="col-2">
            <p-inputNumber #authCode2 [min]="0" [max]="9" formControlName="authCode2" [maxlength]="1"
              class="p-inputtext-sm custom-input-number" (onInput)="handleFocusNext(authCode3)" (onFocus)="clear('authCode2')" (paste)="onPaste($event)"></p-inputNumber>
          </div>

          <div class="col-2">
            <p-inputNumber #authCode3 [min]="0" [max]="9" formControlName="authCode3" [maxlength]="1"
              class="p-inputtext-sm custom-input-number" (onInput)="handleFocusNext(authCode4)" (onFocus)="clear('authCode3')" (paste)="onPaste($event)"></p-inputNumber>
          </div>

          <div class="col-2">
            <p-inputNumber #authCode4 [min]="0" [max]="9" formControlName="authCode4" [maxlength]="1"
              class="p-inputtext-sm custom-input-number" (onInput)="handleFocusNext(authCode5)" (onFocus)="clear('authCode4')" (paste)="onPaste($event)"></p-inputNumber>
          </div>

          <div class="col-2">
            <p-inputNumber #authCode5 [min]="0" [max]="9" formControlName="authCode5" [maxlength]="1"
              class="p-inputtext-sm custom-input-number" (onInput)="handleFocusNext(authCode6)" (onFocus)="clear('authCode5')" (paste)="onPaste($event)"></p-inputNumber>
          </div>

          <div class="col-2">
            <p-inputNumber #authCode6 [min]="0" [max]="9" formControlName="authCode6" [maxlength]="1"
              class="p-inputtext-sm custom-input-number" (onFocus)="clear('authCode6')" (paste)="onPaste($event)"></p-inputNumber>
          </div>
          <div class="col-6 mt-2">
            <p-button label="{{'LoginPage.ConfirmCodeButton' | translate}}" (onClick)="toggleAuth()" [loading]="loading" class="custom-text-button"/>
          </div>
          <div class="col-6 mt-2">
            <p-button  styleClass="p-button-outlined p-button-secondary" label="{{'LoginPage.ResendCodeButton' | translate}}" (onClick)="resendCode()" [loading]="loading" class="custom-text-button"/>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<p-dialog
  header=""
  [(visible)]="updatedPasswordVisible"
  [style]="{width: '35%'}"
  [modal]="true">
  <div class="flex flex-column justify-content-center align-items-center text-center gap-3">
    <span class="material-symbols-outlined check-icon">
      check
    </span>

    <span class="text-xl font-medium text-900">
      {{'MessageService.FridgeStorage.UpdatedPasswordTitle' | translate}}
    </span>

    <span class="text-base font-medium text-800 px-5">
      {{'MessageService.FridgeStorage.UpdatedPasswordDetail' | translate}}
    </span>
  </div>
  <ng-template pTemplate="footer">
    <div class="w-full flex justify-content-center pb-3">
      <p-button
        label="{{'MessageService.FridgeStorage.FinishButton' | translate}}"
        (onClick)="updatedPasswordVisible = false"
        styleClass="p-button p-button-primary"
        class="custom-text-button justify-content-center"></p-button>
    </div>
  </ng-template>
</p-dialog>

